import querystring from 'querystring';

/**
 *
 * @param name
 */
export function getUrlParams(name: string): string;
export function getUrlParams(): any;
export function getUrlParams(name?: string) {
  const { search } = window.location;
  if (search) {
    const obj = querystring.parse(search.split('?')[1]);
    if (name) {
      return obj[name];
    }
    return obj;
  } else {
    return '';
  }
}

/**
 *
 * @param url
 * @param name
 */
export function getParams(url: string, name?: string) {
  const search = url.split('?')[1];
  if (search) {
    const obj = querystring.parse(search);
    if (name) {
      return obj[name];
    }
    return obj;
  } else {
    return '';
  }
}
